import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import {UserManagementService} from 'app/services/user-management.service';
import {Utils} from 'app/utils';
import { XpressClientLocationTypeEnum } from 'app/models';
import { MerchantService, TourOperatorService } from 'app/services';
import { ResponceErrorCode } from 'XpressTransfer/app/transfer/components/transfer/shared/enums/response-error-code.enum';

@Component({
    selector: 'user-management-all-users-details',
    templateUrl: './user-management-all-users-details.component.html',
    styleUrls: ['./user-management-all-users-details.component.scss'],
    providers: [MessageService]
})
export class UserManagementAllUsersDetailsComponent implements OnInit {

    @Output() changedVisibleUserEmit = new EventEmitter<boolean>();
    @Input()
    set _selectedUser(value: any) {
        this.selectedUser = value;
    }

    showMerchants: boolean = false;
    showTourOperators: boolean = false;
    firstLabel: string = 'First';
    lastLabel: string = 'Last';
    roles: Array<any> = [];
    selectedUser: any = undefined;
    users!: any;
    loading: boolean = false;
    showSidebar: boolean = true;
    displayConfirmDialog: boolean = false;
    displayAlreadyExistDialog: boolean = false;
    symbols: string = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-=/|\\~"';

    public xpressZones: any[] = [
        {
            Name: 'Xpress (Manila)',
            Id: XpressClientLocationTypeEnum.Xpress
        },
        {
            Name: 'Boracay',
            Id: XpressClientLocationTypeEnum.Boracay
        },
        {
            Name: 'El Nido',
            Id: XpressClientLocationTypeEnum.ElNido
		},
		{
			Name: 'Dumaguete',
			Id: XpressClientLocationTypeEnum.Dumaguete
		}
    ];

    private MERCHANT = 0;
    private MERCHANT_ACCOUNT_MANAGER = 0;

    private TOUR_OPERATOR = 0;
    private TOUR_OPERATOR_MANAGER = 0;

    public merchants: any[] = [];
    public tourOperators: any[] = [];

    get isUserExist() {
        return this.selectedUser && this.selectedUser.Id;
    }

    constructor(
        private messageService: MessageService,
        private userManagementService: UserManagementService,
        private tourOperatorService: TourOperatorService,
        private merchantService: MerchantService) {
    }

    ngOnInit(): void {
        this.getRoles();
        this.getMerchantsForCombo();
        this.getTourOperatorsForCombo();
    }

    getMerchantsForCombo(): void {
        const dto = {
            IsLimitedByCurrentUser: false,
        };
        this.merchantService.getMerchantsForCombo(dto, this.messageService)
            .then(data => {
                if (data && data.length > 0) {
                    this.merchants = data;
                }
            })
            .catch(err => {
                throw err;
            });
    }

    getTourOperatorsForCombo(): void {
        this.tourOperatorService.getTourOperatorsForCombo(this.messageService)
            .then(data => {
                if (data && data.length > 0) {
                    this.tourOperators = data;
                }
            })
            .catch(err => {
                throw err;
            });
    }

    getRoles() {
        this.loading = true;
        const dto = {
            TimeZoneOffset: Utils.getTimezoneOffset()
        };
        this.userManagementService.getRoles(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.roles = data.Items;
                this.MERCHANT_ACCOUNT_MANAGER = this.roles.find(r => r.Name === 'MerchantAccountManager')?.Id;
                this.MERCHANT = this.roles.find(r => r.Name === 'Merchant')?.Id;

                this.TOUR_OPERATOR_MANAGER = this.roles.find(r => r.Name === 'TourOperatorManager')?.Id;
                this.TOUR_OPERATOR = this.roles.find(r => r.Name === 'TourOperator')?.Id;
                this.onSelectedRoleChange();
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    confirmAction() {
        if (this.isUserExist) {
            this.updateUser();
        } else {
            this.createUser();
        }
    }

    createUser() {
        this.loading = true;
        if (this.selectedUser) {
            const newUser = {
                Id: this.selectedUser.Id,
                FirstName: this.selectedUser.FirstName,
                LastName: this.selectedUser.LastName,
                Email: this.selectedUser.Email,
                Password: this.selectedUser.Password,
                RoleId: this.selectedUser.RoleId,
                LocationTypes: this.selectedUser.AdminLocations,
                Phone: this.selectedUser.Phone,
                IsPartnerAccountManager: this.selectedUser.RoleId === this.MERCHANT_ACCOUNT_MANAGER,
                IsPartner: this.selectedUser.RoleId === this.MERCHANT,
                IsTourOperatorManager: this.selectedUser.RoleId === this.TOUR_OPERATOR_MANAGER,
                IsTourOperator: this.selectedUser.RoleId === this.TOUR_OPERATOR,
                MerchantIds: this.selectedUser.MerchantId,
                TourOperatorIds: this.selectedUser.TourOperatorIds
            };
            this.userManagementService.createUser(newUser, this.messageService)
                .then(data => {
                    this.loading = false;
                    if (!data) {
                        return;
                    }
					if (!data.Success) {
						if (data.ErrorCode === ResponceErrorCode.UserExists) {
                            this.displayConfirmDialog = false;
                            this.displayAlreadyExistDialog = true;
                            return;
                        }

                        this.displayConfirmDialog = false;
                        this.messageService.add({severity: 'error', summary: 'Error', detail: data.ErrorMessage});
                        return;
                    }
                    this.messageService.add({severity: 'success', summary: 'Success', detail: 'Data has been updated'});
                    this.displayConfirmDialog = false;
                    this.showUserDetailsDialog(true);
                })
                .catch(err => {
                    this.displayConfirmDialog = false;
                    this.messageService.add({severity: 'error', summary: 'Error', detail: err});
                    this.showSidebar = false;
                    this.loading = false;
                });
        }
    }

    updateUser() {
        this.loading = true;
        if (this.selectedUser) {
            const updatedUser = {
                Id: this.selectedUser.Id,
                FirstName: this.selectedUser.FirstName,
                LastName: this.selectedUser.LastName,
                Email: this.selectedUser.Email,
                RoleId: this.selectedUser.RoleId,
                Password: this.selectedUser.Password,
                LocationTypes: this.selectedUser.AdminLocations,
                Phone: this.selectedUser.Phone,
                MerchantIds: this.selectedUser.MerchantId
            };
            this.userManagementService.updateUser(updatedUser, this.messageService)
                .then(data => {
                    this.loading = false;
                    if (!data) {
                        return;
                    }
                    if (!data.Success) {
                        this.displayConfirmDialog = false;
                        this.messageService.add({severity: 'error', summary: 'Error', detail: data.ErrorMessage});
                        return;
                    }
                    this.messageService.add({severity: 'success', summary: 'Success', detail: 'Data has been updated'});
                    this.displayConfirmDialog = false;
                })
                .catch(err => {
                    this.loading = false;
                    this.messageService.add({severity: 'error', summary: 'Error', detail: err});
                    this.displayConfirmDialog = false;
                });
        }
    }

    showUserDetailsDialog(increased: any) {
        this.changedVisibleUserEmit.emit(increased);
    }
    showConfirmDialog() {
        this.displayConfirmDialog = !this.displayConfirmDialog;
    }

    changeConfirmDialogVisibility() {
        this.displayConfirmDialog = !this.displayConfirmDialog;
    }

    confirmAlreadyExistDialog() {
        this.displayAlreadyExistDialog = false;
    }

    cancel() {
        this.showUserDetailsDialog(false);
    }

    copyPassword() {
        navigator.clipboard.writeText(this.selectedUser.Password).then(() => {
            this.messageService.add({severity: 'success', summary: 'Copied!', detail: 'Text copied to clipboard.'});
        }).catch(() => {
            this.messageService.add({severity: 'error', summary: 'Error', detail: 'Unable to copy password.'});
        });
    }

    generatePassword() {
        this.selectedUser.Password = '';
        for (let i = 0; i < 16; i++) {
            this.selectedUser.Password  += this.symbols.charAt(Math.floor(Math.random() * this.symbols.length));
        }
    }

    onSelectedRoleChange(){
        this.showMerchants = this.selectedUser.RoleId === this.MERCHANT_ACCOUNT_MANAGER;
        this.showTourOperators = this.selectedUser.RoleId === this.TOUR_OPERATOR_MANAGER;
        this.firstLabel = this.selectedUser.RoleId === this.MERCHANT ? 'Merchant' : 'First';
        this.lastLabel = this.selectedUser.RoleId === this.MERCHANT? 'Business' : 'Last';
    }
}
